import { render, staticRenderFns } from "./UsuariosAtivos.vue?vue&type=template&id=ccef056a&scoped=true"
import script from "./UsuariosAtivos.vue?vue&type=script&lang=js"
export * from "./UsuariosAtivos.vue?vue&type=script&lang=js"
import style0 from "./UsuariosAtivos.vue?vue&type=style&index=0&id=ccef056a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccef056a",
  null
  
)

export default component.exports